import { lazy } from "react";

const SlabCompression = lazy(() => import("../Component/DSAPayout/SlabCompresssion"));
const ManageKanchaneshverBranch = lazy(() =>
  import("../Component/ManageBranch/ManageKanchaneshverBranch")
);
const BranchProposal = lazy(() => import("../Component/ManageBranch/BranchProposal"));
const EditBranch = lazy(() => import("../Component/ManageBranch/EditBranch"));
const KSDPLBranchList = lazy(() => import("../Component/ManageBranch/KSDPLBranchList"));
const CreateProposal = lazy(() => import("../Component/Ksdpl_Branch/CreateProposal"));
const ProposalList = lazy(() => import("../Component/Ksdpl_Branch/ProposalList"));
const EditBranchProposal = lazy(() => import("../Component/Ksdpl_Branch/EditBranchProposal"));
const BranchProposalDetails = lazy(() => import("../Component/Ksdpl_Branch/BranchProposalDetails"));

const masterDataRoutes = [
  { path: "/Slab-Compression", element: <SlabCompression />, protected: true },
  { path: "/lender-list", element: <ManageKanchaneshverBranch />, protected: true },
  { path: "/manage-ksdl-branch-proposal", element: <BranchProposal />, protected: true },
  { path: "/manage-ksdpl-branch", element: <ManageKanchaneshverBranch />, protected: true },
  { path: "/edit-ksdpl-branch/:id", element: <EditBranch />, protected: true },
  { path: "/manage-ksdpl-branch-list", element: <KSDPLBranchList />, protected: true },
  { path: "/ksdpl-branch", element: <ManageKanchaneshverBranch />, protected: true },
  { path: "/create-branch-proposal", element: <CreateProposal />, protected: true },
  { path: "/branch-proposals-list", element: <ProposalList />, protected: true },
  { path: "/edit-branch-proposal/:id", element: <EditBranchProposal />, protected: true },
  {
    path: "/branch-proposal-details/:id",
    element: <BranchProposalDetails />,
    protected: true,
  },
];

export default masterDataRoutes;
